module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "my-download-dialog",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "top-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    staticClass: "title-label"
  }, [_vm._v("Support artists with your contribution")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n      When you download this album, it's reposted to your followers.\n    ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.trackUser.slug
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.trackUser.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.trackUser.slug
    }
  }, [_c('label', {
    staticClass: "user-name"
  }, [_vm._v("\n          " + _vm._s(_vm.trackUser.username) + "\n          "), (_vm.trackUser.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.trackUser.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('user-follow-btn', {
    attrs: {
      "user": _vm.trackUser,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "item-image",
    style: ({
      'background-image': 'url(' + _vm.coverUrl + ')'
    })
  }), _vm._v(" "), (_vm.track) ? _c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.track.name))]) : _c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), (_vm.trackUser.stripe_connected) ? [_c('v-flex', {
    staticClass: "donate-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(5)
      }
    }
  }, [_vm._v("$5")]), _vm._v(" "), _c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(10)
      }
    }
  }, [_vm._v("$10")]), _vm._v(" "), _c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(20)
      }
    }
  }, [_vm._v("$20")]), _vm._v(" "), _c('v-btn', {
    staticClass: "donate-amount-btn",
    nativeOn: {
      "click": function($event) {
        _vm.donateAmount(50)
      }
    }
  }, [_vm._v("$50")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-numeric', {
    staticClass: "donate-amount form-control",
    attrs: {
      "currency": "$",
      "currency-symbol-position": "prefix",
      "separator": ",",
      "precision": 2,
      "min": 1
    },
    model: {
      value: (_vm.donate_amount),
      callback: function($$v) {
        _vm.donate_amount = $$v
      },
      expression: "donate_amount"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "download-btn mt-0",
    nativeOn: {
      "click": function($event) {
        _vm.showPaymentDialog()
      }
    }
  }, [_c('img', {
    staticClass: "pa-2",
    attrs: {
      "src": "/static/images/ic_download_white.png"
    }
  }), _vm._v("Download\n      ")])], 1)], 2), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.trackUser],
      "amount": _vm.donate_amount_by_cent,
      "dismiss": _vm.hidePaymentDialog,
      "finish": _vm.sendLove
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82751cd4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadmodal.vue
// module id = 1803
// module chunks = 180